import React, { PropsWithChildren } from 'react'
import { CheckboxUiInterface } from 'src/shared/components/checkbox/checkbox-ui.schema'
import CheckboxInputUi from 'src/shared/components/checkbox/ui/CheckboxInputUi'
import CheckboxLabelUi from 'src/shared/components/checkbox/ui/CheckboxLabelUi'
import CheckboxUi from 'src/shared/components/checkbox/ui/CheckboxUi'

export interface CheckboxProps {
  uiProps?: CheckboxUiInterface
  checked: boolean
  onChangeHandler: React.ChangeEventHandler<HTMLInputElement>
}

const Checkbox = ({
  uiProps,
  checked,
  onChangeHandler,
  children,
}: PropsWithChildren<CheckboxProps>) => (
  <CheckboxUi
    id={uiProps?.htmlAttrId}
    textAlign={uiProps?.textAlign}
    mobileTextAlign={uiProps?.mobileTextAlign}
  >
    <CheckboxLabelUi
      fontSize={uiProps?.fontSize}
      mobileFontSize={uiProps?.mobileFontSize}
      color={uiProps?.color}
      mobileColor={uiProps?.mobileColor}
      fontFamily={uiProps?.fontFamily}
      mobileFontFamily={uiProps?.mobileFontFamily}
      lineHeight={uiProps?.lineHeight}
      mobileLineHeight={uiProps?.mobileLineHeight}
    >
      <CheckboxInputUi
        type="checkbox"
        onChange={onChangeHandler}
        defaultChecked={checked}
        disabled={uiProps?.isCheckboxDisabled}
      />
      {children}
    </CheckboxLabelUi>
  </CheckboxUi>
)

export default Checkbox
